import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { propTypes as rolePropTypes } from 'shared/proptypes/Role';
import Tag from 'shared/components/Tag';
import styles from './styles.module.scss';

const AddSkillToProfile = ({ entity }) => {
  const { t } = useTranslation('userportal');

  if (!entity) {
    return null;
  }

  return (
    <div>
      <p>
        {t('page.job.add_roleToProfileDescription')}
      </p>
      <div className={styles.tagLine}>
        <Tag
          noTooltip
          slug={entity.slug}
          type="role"
          kind="profile-form"
        >
          {t(`common:role.${entity.slug}`)}
        </Tag>
      </div>
    </div>
  );
};

AddSkillToProfile.propTypes = {
  entity: PropTypes.shape(rolePropTypes),
};

AddSkillToProfile.defaultProps = {
  entity: null,
};

export default AddSkillToProfile;
